import { choose } from '../../utils/platform';
import CostLinesEditorDesktop from './CostLinesEditor.desktop';
import CostLinesEditorMobile from './CostLinesEditor.mobile';

export default choose(CostLinesEditorDesktop, CostLinesEditorMobile);
